<main class="profile-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'profile.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="profile-head">
    <div class="profile-head__kicker">
      <span>{{ 'profile.kicker' | translate }}</span>
      @if (memberSinceMonthYear(); as ms) {
        <span class="profile-head__dot">·</span>
        <span>{{ 'profile.memberSinceShort' | translate: { date: ms } }}</span>
      }
    </div>
    <h1 class="profile-head__title">
      {{ 'profile.titleMain' | translate }}
      <span class="profile-head__accent">{{ 'profile.titleAccent' | translate }}</span>
    </h1>
  </div>

  <div class="profile-hero">
    <div class="profile-hero__row">
      <div class="profile-hero__avatar">
        @if (avatarUrl(); as url) {
          <img class="profile-hero__avatar-img" [src]="url" alt="" />
        } @else {
          <span>{{ initial() }}</span>
        }
      </div>
      <div class="profile-hero__identity">
        <div class="profile-hero__name">{{ displayName() }}</div>
        <div class="profile-hero__email">{{ email() }}</div>
      </div>
    </div>
  </div>

  @if (memberSinceFullDate(); as ms) {
    <div class="member-since">
      <span class="member-since__icon" aria-hidden="true">
        <sz-icon name="calendar" [size]="14" />
      </span>
      <span
        ><b>{{ 'profile.memberSinceLong' | translate }}</b> {{ ms }}</span
      >
    </div>
  }

  <button type="button" class="cta cta--secondary" [routerLink]="editPath">
    <sz-icon name="edit" [size]="16" />
    <span>{{ 'profile.editCta' | translate }}</span>
    <sz-icon name="arrow-right" [size]="14" />
  </button>

  <button type="button" class="cta cta--secondary" (click)="goContact()">
    <sz-icon name="mail" [size]="16" />
    <span>{{ 'profile.contactCta' | translate }}</span>
    <sz-icon name="arrow-right" [size]="14" />
  </button>

  @if (isAdmin()) {
    <button type="button" class="cta cta--secondary" (click)="goStats()">
      <sz-icon name="chart" [size]="16" />
      <span>{{ 'admin.title' | translate }}</span>
      <sz-icon name="arrow-right" [size]="14" />
    </button>
  }

  <button type="button" class="cta cta--destructive" (click)="onSignOut()">
    <sz-icon name="log-out" [size]="16" />
    <span>{{ 'profile.menu.signOutCta' | translate }}</span>
  </button>

  <div class="legal-row">
    <a [routerLink]="privacyPath">{{ 'profile.privacyLink' | translate }}</a>
    <span class="legal-row__sep" aria-hidden="true">·</span>
    <a [routerLink]="termsPath">{{ 'profile.termsLink' | translate }}</a>
  </div>

  <div class="app-version">v{{ appVersion }}</div>
</main>
